import { Box, TextField, MenuItem, FormControl, InputLabel, Select, Autocomplete, Typography } from "@mui/material";
import { useForm, Controller } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import EntryButton from "../../UI/EntryButton";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { vendorListAction } from "../../asyncActions/vendorActions";
import SubmitButton from "../../UI/SubmitButton";
import { getVendorProductItemAction } from "../../asyncActions/productAction";  // Импорт действия для получения данных продукта
import { clearForm } from "../../store/productSlice";
import { setModal } from "../../store/modalSlice";

function VendorProductDetailPage() {
    const { id } = useParams();
    const type = id ? 'edit' : 'create';
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { control, handleSubmit, setValue, formState: { errors } } = useForm();

    const { vendorList, form, formLoad } = useSelector(store => store.product.vendorProduct);
    const { dataLoad } = useSelector(store => store.product);

    useEffect(() => {
        dispatch(vendorListAction());
        if (type === 'edit' && id) {
            dispatch(getVendorProductItemAction(id));
        }
        return () => {
            dispatch(clearForm())
        }
    }, [dispatch, id, type]);

    const vendorOptions = vendorList.map(el => ({ label: el.full_name, value: el.id }));


    const onSubmit = (data) => {
        let modalPayload = {
            active: true,
            data: {
                path: 'vendor/product',
                type: 'vendorProduct'
            }
        }
        if (type === 'create') {
            modalPayload.data.text = 'Подтвердить создание продукта вендора'
            modalPayload.content = 'vendorProductCreate'
            modalPayload.data.payload = data
            dispatch(setModal(modalPayload))
        } else if (type === 'edit') {
            const param = {
                id,
                body: data
            }
            modalPayload.data.text = 'Подтвердить изменение продукта вендора'
            modalPayload.content = 'vendorProductEdit'
            modalPayload.data.payload = param
            console.log(param.body);
            dispatch(setModal(modalPayload))
        }
    };

    useEffect(() => {
        if (form.id) {
            setValue('name', form.name)
            setValue('unit_type', form.unit_type)
            setValue('product_type', form.product_vendor_type)

            const selectedVendorIds = form.vendors.map(vendor => vendor.id);
            setValue("vendors", selectedVendorIds)
        }
    }, [form.id, setValue])
    return (
        <Box sx={{ width: '100%', maxWidth: '800px', margin: 'auto', p: 2 }}>
            <Typography variant="h4">{type === 'edit' ? `Edit vendor-product ${form?.name}` : "Create new vendor-product"}</Typography>
            <Box sx={{ display: 'flex', justifyContent: 'start', my: 2 }}>
                <EntryButton onClick={() => navigate(-1)}>Back</EntryButton>
            </Box>
            <Box>
                {!dataLoad && !formLoad ?
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Controller
                            name="name"
                            control={control}
                            rules={{ required: "Имя продукта обязательно" }}
                            render={({ field }) => (
                                <TextField
                                    {...field}
                                    fullWidth
                                    label="Имя"
                                    margin="normal"
                                    error={!!errors.name}
                                    helperText={errors.name?.message}
                                />
                            )}
                        />
                        <Controller
                            name="unit_type"
                            control={control}
                            rules={{ required: "Тип обязателен" }}
                            render={({ field }) => (
                                <TextField
                                    {...field}
                                    fullWidth
                                    label="Тип"
                                    margin="normal"
                                    error={!!errors.unit_type}
                                    helperText={errors.unit_type?.message}
                                />
                            )}
                        />
                        <FormControl fullWidth margin="normal">
                            <InputLabel>Product type</InputLabel>
                            <Controller
                                name="product_type"
                                control={control}
                                rules={{
                                    required: "Product type requared",
                                }}
                                render={({ field }) => (
                                    <Select
                                        {...field}
                                        label="Product type"
                                        error={!!errors.branch}
                                        value={field.value || []}
                                    >
                                        <MenuItem value={1}>Warehouse</MenuItem>
                                        <MenuItem value={2}>Branch</MenuItem>
                                        <MenuItem value={3}>All</MenuItem>

                                    </Select>
                                )}
                            />
                            {errors.branch && <p style={{ color: 'red' }}>{errors.branch.message}</p>}
                        </FormControl>
                        <FormControl fullWidth margin="normal">
                            <Controller
                                name="vendors"
                                control={control}
                                rules={{ required: "Vendor required" }}
                                render={({ field }) => (
                                    <Autocomplete
                                        multiple
                                        options={vendorOptions}
                                        getOptionLabel={(option) => option.label}
                                        value={vendorOptions.filter(option => field.value?.includes(option.value))}
                                        onChange={(_, newValue) => field.onChange(newValue.map(option => option.value))}
                                        renderInput={(params) => (
                                            <TextField {...params} label="Vendors" error={!!errors.vendors} helperText={errors.vendors?.message} />
                                        )}
                                    />
                                )}
                            />
                        </FormControl>
                        <SubmitButton type="submit" variant="contained" color="primary" fullWidth sx={{ mt: 2 }}>
                            {type === 'edit' ? "Save" : "Create"}
                        </SubmitButton>
                    </form>
                    : <p>Loading ...</p>
                }
            </Box>
        </Box>
    );
}

export default VendorProductDetailPage;
